import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";

const ResetPassword = ({ isOpen, toggleModal, onSubmit }) => {
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setForm({ password: "", confirmPassword: "" });
      setErrors({});
      setApiError("");
      setLoading(false);
      setShowPassword(false);
      setShowConfirmPassword(false);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let err = {};

    if (!form.password) err.password = "Password is required";
    else if (form.password.length < 8)
      err.password = "Minimum 8 characters required";

    if (!form.confirmPassword)
      err.confirmPassword = "Confirm password is required";
    else if (form.password !== form.confirmPassword)
      err.confirmPassword = "Passwords do not match";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");

    if (!validate()) return;

    try {
      setLoading(true);
      const res = await onSubmit({
        newPassword: form.password,
        confirmPassword: form.confirmPassword,
      });

      if (res?.code !== 200) {
        setApiError(res?.message || "Reset failed");
      }
      // ✅ modal closes ONLY from parent on success
    } catch (err) {
      setApiError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {}}
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered"
    >
      <ModalHeader>Set Your Password</ModalHeader>

      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {/* Password */}
          <Label>Password</Label>
          <InputGroup>
            <Input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={handleChange}
              invalid={!!errors.password}
              placeholder="Enter new password"
            />
            <InputGroupText
              style={{ cursor: "pointer" }}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
            </InputGroupText>
            <FormFeedback>{errors.password}</FormFeedback>
          </InputGroup>

          {/* Confirm Password */}
          <Label className="mt-3">Confirm Password</Label>
          <InputGroup>
            <Input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              invalid={!!errors.confirmPassword}
              placeholder="Confirm password"
            />
            <InputGroupText
              style={{ cursor: "pointer" }}
              onClick={() => setShowConfirmPassword((prev) => !prev)}
            >
              <i
                className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
              />
            </InputGroupText>
            <FormFeedback>{errors.confirmPassword}</FormFeedback>
          </InputGroup>

          {/* API Error */}
          {apiError && <div className="text-danger mt-3">{apiError}</div>}

          {/* Submit */}
          <div className="text-end mt-4">
            <Button
              className="btn-gradient-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Changing Password..." : "Set Password"}
            </Button>
          </div>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default ResetPassword;
